import React from 'react';
import { BaseInputProps, SmartTagsTextInputWithLoad, useFormContext } from 'ui-builder';
import { useSmartTagsService } from 'nekst-api';

export interface EventTitleSmartTagsInputProps extends BaseInputProps {

}

export function EventTitleSmartTagsInput(props: EventTitleSmartTagsInputProps) {
  const smartTagsService = useSmartTagsService();
  const formContext = useFormContext();

  const projectId = formContext.data!.projectId;


  return (
    <SmartTagsTextInputWithLoad
      {...props}
      getTagsMethod={async () => {
        if (projectId)  {
          return await smartTagsService.getSmartTagsByProjectId(projectId);
        } else  {
          return [];
        }

      }}
      dependencies={[projectId]}
    />
  );
}
